import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import imgx from '../../../assets/t1.png'
import dot from '../../../assets/save.svg'
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { Link } from 'react-router-dom'
import bookmark from '../../../assets/bookmark.png';
import saveicon from "../../../assets/save.svg";
import user2 from "../../../assets/user.png";
import { auth, db } from '../../../firebase';
const SearchFolio = ({
    Image,
    title,
    name,
    onclick,
    id,
    postedby,
    desc,
}) => {
    const [save, setsave] = useState(false);
    const [profPic, setprofPic] = useState(null);
    const changeSaved = () => {
        setsave(!save);
    }
    // useEffect(() => {
    //     db
    //         .collection("users")
    //         .doc(postedby)
    //         .get()
    //         .then((doc) => {
    //             // console.log(doc.data().profilePic);
    //             if (doc.data().profilePic === "")
    //                 setprofPic(user2);
    //             else
    //                 setprofPic(doc.data().profilePic);
    //             console.log("hii");
    //         });
    // }, [postedby])





    return (
        <>

            <Item>
                <div onClick={() => onclick(id)}>
                    <Imagex src={Image} alt="oops nothing to show" />
                </div>

                <Body>

                    <div style={{ display: 'flex' }}>
                        <Title>{title}</Title>

                        <span onClick={changeSaved} style={{ marginLeft: "auto" }}>{save ? <BookImg src={bookmark} /> : <Icon src={saveicon} save={save} />}</span>
                    </div>

                    <div style={{ display: 'flex', alignItems: "center" }}>
                        <img src={profPic} style={{ height: '27px', width: '27px', borderRadius: '50%' }} alt="" />
                        <Name>{name}</Name>
                    </div>
                    <Div>{desc}</Div>
                </Body>


            </Item>
        </>
    )
}

const Item = styled.div`
    display:flex;
    flex-direction:row;
    margin-top: 20px;
    width: 730px;
    margin-left: 35px;
    @media (max-width: 1115px){
        width: 600px;
    };
    @media (max-width: 985px){
    margin-left: 0px;
    };
    @media (max-width: 950px){
        width: 450px;
    margin-left: 35px;
    };
    @media (max-width: 763px){
        margin-left: 0px;
      };
    @media (max-width: 500px){
        width: 320px;
    };
`

const Body = styled.div`
width: 100%;
margin-left: 15px;
`

const BookImg = styled.img`
    width: 14px;
`

const Icon = styled.img.attrs(props => ({
}))`
    align-self: right;
`;

const Title = styled.p`
    font-size:20px;
    width: 90%;
    margin-bottom: 10px;
    overflow: hidden;
    word-break: break-word;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    @media (max-width: 950px){
    font-size:18px;
    };
    @media (max-width: 500px){
    font-size:16px;
    };
`
const Name = styled.p`
    margin: 0;
    font-family:Rubik;
    font-size:14px;
    padding-left: 8px;
    @media (max-width: 950px){
        font-size:13px;
    };
    @media (max-width: 500px){
        font-size:12px;
    };
`

const Div = styled.div`
    width: 90%;
    font-size:13px;
    margin-top: 35px;
    word-break: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    @media (max-width: 950px){
        font-size:12px;
    };
    @media (max-width: 500px){
        margin-top: 20px;
        font-size:11px;
    };
`

const Imagex = styled.img`
    width: 149px;
    height: 198px;
    @media (max-width: 950px){
        width: 130px;
        height: 172.75px;
    };
    @media (max-width: 500px){
        width: 105px;
        height: 140px;
    };
`
const DotIcon = styled.img.attrs(props => ({
    src: dot
}))`
    
`

const Page = styled.p`
    position: relative;
    margin-top: 3vh;
    font-family:Rubik;
    font-size:15px;
    color: #868585;
`

export default SearchFolio;